import React from "react";

export default function ErrorBox({ message, className }) {
  return <div className={ className ? `alert alert-danger ${className}` : "alert alert-danger"} role="alert">{message}</div>;
}
